<template>
  <div />
</template>

<script>
import profileMixin from '~/mixins/profileMixin';

export default {
  name: 'ProductProfile',
  mixins: [profileMixin],
  layout: 'product',
};
</script>
